module.exports = __webpack_public_path__ + "static/img/5.19e9a7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/5.png
// module id = IeNw
// module chunks = 0